export function getTwoLetterOrInitials(name: string) {
  const nameArray = name.split(" ");

  if (nameArray.length === 1) {
    // For single-word names, get the first two letters if available.
    return name.slice(0, 2).toUpperCase();
  } else {
    // For multi-word names, get the first letter of the first name and the first letter of the surname.
    const firstName = nameArray[0];
    const surname = nameArray[nameArray.length - 1];
    return `${firstName.charAt(0).toUpperCase()}${surname
      .charAt(0)
      .toUpperCase()}`;
  }
}
